import { Button } from '@mui/material';
import React, { useState } from 'react'

const HeaderButtonForBusiness = (props) => {

  const [ isBusinessButtonHovered, setIsBusinessButtonHovered ] = useState(false);

  const handleBusinessButtonMouseOut = () => {
    setIsBusinessButtonHovered(false);
  }
  const handleBusinessButtonMouseOver = () => {
    setIsBusinessButtonHovered(true);
  };

  return (
    <Button
      onMouseOut={handleBusinessButtonMouseOut}
      onMouseOver={handleBusinessButtonMouseOver}
      href="/business/"
      sx={{
        background: isBusinessButtonHovered ? 
          "linear-gradient(to right bottom, red, purple)" : 
          "linear-gradient(to right bottom, purple, red)",
        boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
        color: "#fff",
        fontStyle: "italic",
        transition: "200ms ease all",
      }}
    >
      For Business
    </Button>
  )
}

export default HeaderButtonForBusiness